export default {
  AED: {
    en: 'UAE Dirham',
    zh: '阿联酋迪拉姆'
  },
  AFN: {
    en: 'Afghani',
    zh: '阿富汗尼'
  },
  ALL: {
    en: 'Lek',
    zh: '列克'
  },
  AMD: {
    en: 'Armenian Dram',
    zh: '亚美尼亚德拉姆'
  },
  ANG: {
    en: 'Netherlands Antillean Guilder',
    zh: '荷属安的列斯盾'
  },
  AOA: {
    en: 'Kwanza',
    zh: '安哥拉宽扎'
  },
  ARS: {
    en: 'Argentine Peso',
    zh: '阿根廷比索'
  },
  AUD: {
    en: 'Australian Dollar',
    zh: '澳币'
  },
  AWG: {
    en: 'Aruban Florin',
    zh: '阿鲁巴岛弗罗林'
  },
  AZN: {
    en: 'Azerbaijanian Manat',
    zh: '阿塞拜疆马纳特'
  },
  BAM: {
    en: 'Convertible Mark',
    zh: '可折换马克'
  },
  BBD: {
    en: 'Barbados Dollar',
    zh: '巴巴多斯元'
  },
  BDT: {
    en: 'Bangladeshi Taka',
    zh: '孟加拉塔卡'
  },
  BGN: {
    en: 'Bulgarian Lev',
    zh: '保加利亚列弗'
  },
  BHD: {
    en: 'Bahraini Dinar',
    zh: '巴林第纳尔'
  },
  BIF: {
    en: 'Burundi Franc',
    zh: '布隆迪法郎'
  },
  BMD: {
    en: 'Bermudian Dollar',
    zh: '百慕大元'
  },
  BND: {
    en: 'Brunei Dollar',
    zh: '文莱元'
  },
  BOB: {
    en: 'Bolivian Boliviano',
    zh: '玻利维亚诺'
  },
  BOV: {
    en: 'Mvdol',
    zh: '姆夫多尔'
  },
  BRL: {
    en: 'Brazilian Real',
    zh: '巴西雷亚尔'
  },
  BSD: {
    en: 'Bahamian Dollar',
    zh: '巴哈马元'
  },
  BTN: {
    en: 'Ngultrum',
    zh: '不丹努尔特鲁姆'
  },
  BWP: {
    en: 'Pula',
    zh: '普拉'
  },
  BYN: {
    en: 'Belarussian Ruble',
    zh: '白俄罗斯卢布'
  },
  BZD: {
    en: 'Belize Dollar',
    zh: '貝里斯元'
  },
  CAD: {
    en: 'Canadian Dollar',
    zh: '加拿大元'
  },
  CDF: {
    en: 'Congolese Franc',
    zh: '刚果法郎'
  },
  CHE: {
    en: 'WIR Euro',
    zh: 'WIR欧元'
  },
  CHF: {
    en: 'Swiss Franc',
    zh: '瑞士法郎'
  },
  CHW: {
    en: 'WIR Franc',
    zh: 'WIR法郎'
  },
  CLF: {
    en: 'Unidad de Fomento',
    zh: '智利UF值'
  },
  CLP: {
    en: 'Chilean Peso',
    zh: '智利比索'
  },
  CNH: {
    en: 'Chinese Yuan - Offshore',
    zh: '离岸人民币'
  },
  CNY_ONSHORE: {
    en: 'Chinese Yuan - Onshore',
    zh: '在岸人民币'
  },
  CNY: {
    en: 'Chinese Yuan',
    zh: '人民币'
  },
  COP: {
    en: 'Colombian Peso',
    zh: '哥伦比亚比索'
  },
  COU: {
    en: 'Unidad de Valor Real',
    zh: '哥伦比亚Real'
  },
  CRC: {
    en: 'Costa Rican Colon',
    zh: '哥斯达黎加科朗'
  },
  CUC: {
    en: 'Peso Convertible',
    zh: '可折换比锁'
  },
  CUP: {
    en: 'Cuban Peso',
    zh: '古巴比索'
  },
  CVE: {
    en: 'Cabo Verde Escudo',
    zh: '佛得角埃斯库多'
  },
  CZK: {
    en: 'Czech Koruna',
    zh: '捷克克朗'
  },
  DJF: {
    en: 'Djibouti Franc',
    zh: '吉布提法郎'
  },
  DKK: {
    en: 'Danish Krone',
    zh: '丹麦克朗'
  },
  DOP: {
    en: 'Dominican Peso',
    zh: '多米尼加比索'
  },
  DZD: {
    en: 'Algerian Dinar',
    zh: '阿尔及利亚第纳尔'
  },
  EGP: {
    en: 'Egyptian Pound',
    zh: '埃及镑'
  },
  ERN: {
    en: 'Eritrea Nakfa',
    zh: '厄立特里亚纳克法'
  },
  ETB: {
    en: 'Ethiopian Birr',
    zh: '埃塞俄比亚比尔'
  },
  EUR: {
    en: 'Euro',
    zh: '欧元'
  },
  FJD: {
    en: 'Fiji Dollar',
    zh: '斐济元'
  },
  FKP: {
    en: 'Falkland Islands Pound',
    zh: '福克兰群岛镑'
  },
  GBP: {
    en: 'Great Britain Pound',
    zh: '英镑'
  },
  GEL: {
    en: 'Lari',
    zh: '格鲁吉亚拉里'
  },
  GHS: {
    en: 'Ghana Cedi',
    zh: '加纳塞地'
  },
  GIP: {
    en: 'Gibraltar Pound',
    zh: '直布罗陀镑'
  },
  GMD: {
    en: 'Dalasi',
    zh: '法拉西'
  },
  GNF: {
    en: 'Guinea Franc',
    zh: '几内亚法郎'
  },
  GTQ: {
    en: 'Quetzal',
    zh: '格查尔'
  },
  GYD: {
    en: 'Guyana Dollar',
    zh: '圭亚那元'
  },
  HKD: {
    en: 'Hong Kong Dollar',
    zh: '港币'
  },
  HNL: {
    en: 'Lempira',
    zh: '伦皮拉'
  },
  HRK: {
    en: 'Croatian Kuna',
    zh: '克罗地亚库纳'
  },
  HTG: {
    en: 'Gourde',
    zh: '古德'
  },
  HUF: {
    en: 'Hungarian Forint',
    zh: '匈牙利福林'
  },
  IDR: {
    en: 'Indonesian Rupiah',
    zh: '印尼盾'
  },
  ILS: {
    en: 'Israeli New Shekel',
    zh: '以色列谢克尔'
  },
  INR: {
    en: 'Indian Rupee',
    zh: '印度卢比'
  },
  IQD: {
    en: 'Iraqi Dinar',
    zh: '伊拉克第纳尔'
  },
  IRR: {
    en: 'Iranian Rial',
    zh: '伊朗里亚尔'
  },
  ISK: {
    en: 'Iceland Krona',
    zh: '冰岛克朗'
  },
  JMD: {
    en: 'Jamaican Dollar',
    zh: '牙买加元'
  },
  JOD: {
    en: 'Jordanian Dinar',
    zh: '约旦第纳尔'
  },
  JPY: {
    en: 'Japanese Yen',
    zh: '日元'
  },
  KES: {
    en: 'Kenyan Shilling',
    zh: '肯尼亚先令'
  },
  KGS: {
    en: 'Som',
    zh: '吉尔吉斯斯坦索姆'
  },
  KHR: {
    en: 'Riel',
    zh: '瑞尔'
  },
  KMF: {
    en: 'Comoro Franc',
    zh: '科摩罗法郎'
  },
  KPW: {
    en: 'North Korean Won',
    zh: '朝鲜元'
  },
  KRW: {
    en: 'Korean Won',
    zh: '韩元'
  },
  KWD: {
    en: 'Kuwaiti Dinar',
    zh: '科威特第纳尔'
  },
  KYD: {
    en: 'Cayman Islands Dollar',
    zh: '开曼群岛元'
  },
  KZT: {
    en: 'Tenge',
    zh: '哈萨克坚戈'
  },
  LAK: {
    en: 'Kip',
    zh: '基普'
  },
  LBP: {
    en: 'Lebanese Pound',
    zh: '黎巴嫩镑'
  },
  LKR: {
    en: 'Sri Lanka Rupee',
    zh: '斯里兰卡卢比'
  },
  LRD: {
    en: 'Liberian Dollar',
    zh: '利比里亚元'
  },
  LSL: {
    en: 'Loti',
    zh: '莱索托洛蒂'
  },
  LYD: {
    en: 'Libyan Dinar',
    zh: '利比亚第纳尔'
  },
  MAD: {
    en: 'Moroccan Dirham',
    zh: '摩洛哥迪拉姆'
  },
  MDL: {
    en: 'Moldovan Leu',
    zh: '摩尔多瓦列伊'
  },
  MGA: {
    en: 'Malagasy Ariary',
    zh: '马达加斯加阿里亚里'
  },
  MKD: {
    en: 'Denar',
    zh: '马其顿第纳尔'
  },
  MMK: {
    en: 'Kyat',
    zh: '缅元'
  },
  MNT: {
    en: 'Tugrik',
    zh: '图格里克'
  },
  MOP: {
    en: 'Pataca',
    zh: '澳门元'
  },
  MRU: {
    en: 'Ouguiya',
    zh: '毛里塔尼亚乌吉亚'
  },
  MUR: {
    en: 'Mauritius Rupee',
    zh: '毛里求斯卢比'
  },
  MVR: {
    en: 'Rufiyaa',
    zh: '马尔代夫卢比'
  },
  MWK: {
    en: 'Kwacha',
    zh: '赞比亚克瓦查'
  },
  MXN: {
    en: 'Mexican Peso',
    zh: '墨西哥比索'
  },
  MXV: {
    en: 'Mexican Unidad de Inversion (UDI)',
    zh: '转换墨西哥比索'
  },
  MYR: {
    en: 'Malaysian Ringgit',
    zh: '林吉特'
  },
  MZN: {
    en: 'Mozambique Metical',
    zh: '莫桑比克美提卡'
  },
  NAD: {
    en: 'Namibia Dollar',
    zh: '纳米比亚元'
  },
  NGN: {
    en: 'Nigerian Naira',
    zh: '尼日利亚奈拉'
  },
  NIO: {
    en: 'Cordoba Oro',
    zh: 'Cordoba Oro'
  },
  NOK: {
    en: 'Norwegian Krone',
    zh: '挪威克朗'
  },
  NPR: {
    en: 'Nepalese Rupee',
    zh: '尼泊尔卢比'
  },
  NZD: {
    en: 'New Zealand Dollar',
    zh: '新西兰元'
  },
  OMR: {
    en: 'Rial Omani',
    zh: '阿曼里亚尔'
  },
  PAB: {
    en: 'Balboa',
    zh: '巴拿马巴波亚'
  },
  PEN: {
    en: 'Peruvian Sol',
    zh: '秘鲁索尔'
  },
  PGK: {
    en: 'Kina',
    zh: '巴布新几内亚基纳'
  },
  PHP: {
    en: 'Philippine Peso',
    zh: '菲律宾比索'
  },
  PKR: {
    en: 'Pakistan Rupee',
    zh: '巴基斯坦卢比'
  },
  PLN: {
    en: 'Polish Zloty',
    zh: '波兰兹罗提'
  },
  PYG: {
    en: 'Guarani',
    zh: '巴拉圭瓜拉尼'
  },
  QAR: {
    en: 'Qatari Rial',
    zh: '卡塔尔里亚尔'
  },
  RON: {
    en: 'Romanian Leu',
    zh: '罗马尼亚列伊'
  },
  RSD: {
    en: 'Serbian Dinar',
    zh: '塞尔维亚第纳尔'
  },
  RUB: {
    en: 'Russian Ruble',
    zh: '卢布'
  },
  RWF: {
    en: 'Rwanda Franc',
    zh: '卢旺达法郎'
  },
  SAR: {
    en: 'Saudi Riyal',
    zh: '亚尔'
  },
  SBD: {
    en: 'Solomon Islands Dollar',
    zh: '所罗门元'
  },
  SCR: {
    en: 'Seychelles Rupee',
    zh: '塞舌尔卢比'
  },
  SDG: {
    en: 'Sudanese Pound',
    zh: '苏丹镑'
  },
  SEK: {
    en: 'Swedish Krona',
    zh: '瑞典克朗'
  },
  SGD: {
    en: 'Singapore Dollar',
    zh: '新加坡元'
  },
  SHP: {
    en: 'Saint Helena Pound',
    zh: '圣赫勒拿磅'
  },
  SLL: {
    en: 'Leone',
    zh: '利昂'
  },
  SOS: {
    en: 'Somali Shilling',
    zh: '索马里先令'
  },
  SRD: {
    en: 'Surinam Dollar',
    zh: '苏利南元'
  },
  SSP: {
    en: 'South Sudanese Pound',
    zh: '南苏丹镑'
  },
  STN: {
    en: 'Dobra',
    zh: '圣多美多布拉'
  },
  SVC: {
    en: 'El Salvador Colon',
    zh: '萨尔瓦多科朗'
  },
  SYP: {
    en: 'Syrian Pound',
    zh: '叙利亚镑'
  },
  SZL: {
    en: 'Lilangeni',
    zh: '吉尼'
  },
  THB: {
    en: 'Thai Baht',
    zh: '泰铢'
  },
  TJS: {
    en: 'Somoni',
    zh: '塔吉克索莫尼'
  },
  TMT: {
    en: 'Turkmenistan New Manat',
    zh: 'Turkmenistan New Manat'
  },
  TND: {
    en: 'Tunisian Dinar',
    zh: '突尼斯第纳尔'
  },
  TOP: {
    en: 'Pa’anga',
    zh: 'Pa’anga'
  },
  TRY: {
    en: 'Turkish Lira',
    zh: '土耳其里拉'
  },
  TTD: {
    en: 'Trinidad and Tobago Dollar',
    zh: '特立尼达多巴哥元'
  },
  TWD: {
    en: 'New Taiwan Dollar',
    zh: '新台币'
  },
  TZS: {
    en: 'Tanzanian Shilling',
    zh: '坦桑尼亚先令'
  },
  UAH: {
    en: 'Hryvnia',
    zh: '乌克兰格里夫纳'
  },
  UGX: {
    en: 'Uganda Shilling',
    zh: '乌干达先令'
  },
  USD: {
    en: 'United States Dollar',
    zh: '美元'
  },
  USN: {
    en: 'US Dollar (Next day)',
    zh: '美元（次日）'
  },
  UYI: {
    en: 'Uruguay Peso en Unidades Indexadas (URUIURUI)',
    zh: 'Uruguay Peso en Unidades Indexadas (URUIURUI)'
  },
  UYU: {
    en: 'Uruguayan Peso',
    zh: '乌拉圭比索'
  },
  UZS: {
    en: 'Uzbekistan Sum',
    zh: '乌兹别克斯坦苏姆'
  },
  VEF: {
    en: 'Bolivar',
    zh: '委内瑞拉玻利瓦尔'
  },
  VND: {
    en: 'Vietnamese Dong',
    zh: '越南盾'
  },
  VUV: {
    en: 'Vatu',
    zh: '瓦努阿图'
  },
  WST: {
    en: 'Tala',
    zh: '萨摩亚塔拉'
  },
  XAF: {
    en: 'CFA Franc BEAC',
    zh: '中非金融合作法郎'
  },
  XCD: {
    en: 'East Caribbean Dollar',
    zh: '东加勒比元'
  },
  XDR: {
    en: 'SDR (Special Drawing Right)',
    zh: 'SDR特别提款权'
  },
  XOF: {
    en: 'CFA Franc BCEAO',
    zh: '非共体法郎'
  },
  XPF: {
    en: 'CFP Franc',
    zh: 'CFP法郎'
  },
  XSU: {
    en: 'Sucre',
    zh: 'Sucre'
  },
  XUA: {
    en: 'ADB Unit of Account',
    zh: '亚行帐户单位'
  },
  YER: {
    en: 'Yemeni Rial',
    zh: '也门里亚尔'
  },
  ZAR: {
    en: 'South African Rand',
    zh: '兰特'
  },
  ZMW: {
    en: 'Zambian Kwacha',
    zh: '赞比亚克瓦查'
  },
  ZWL: {
    en: 'Zimbabwe Dollar',
    zh: '津巴布韦元'
  }
};